/*
 * Single source of truth for every word and every company datum on the site.
 * Logistics Bridge — by X New Line, Guangzhou / China.
 */
export const COMPANY = {
    name: { ar: "إكس نيو لاين", en: "X New Line" },
    brand: "Logistics Bridge",
    contactPerson: "Hesham Nasser",
    phones: [
        { display: "+86 132 6594 3578", href: "tel:+8613265943578" },
        { display: "+86 132 4482 1495", href: "tel:+8613244821495" },
        { display: "+86 195 4040 5041", href: "tel:+8619540405041" },
    ],
    phoneDisplay: "+86 132 6594 3578",
    telHref: "tel:+8613265943578",
    waHref: "https://wa.me/8613265943578",
    email: "x.newline1@gmail.com",
    emailHref: "mailto:x.newline1@gmail.com",
    address: {
        ar: "غرفة 1109، الوحدة 2، مبنى 6، مجمع جينشا دادوهوي، 172 طريق هوانجو الثاني، منطقة باييون، قوانغجو، مقاطعة قوانغدونغ، الصين 510168",
        en: "Room 1109, Unit 2, Building 6, Jinsha Dadouhui, No.172 Huanzhou 2nd Road, Baiyun District, Guangzhou, Guangdong, China 510168",
    },
    coords: "23.1291° N, 113.2644° E",
};

export const SEO = {
    ar: {
        title: "Logistics Bridge | الاستيراد والتصدير والخدمات اللوجستية من الصين",
        desc: "Logistics Bridge — التوريد من الصين والاستيراد والتصدير والتخليص الجمركي والشحن الدولي بحريًا وجويًا من قوانغجو إلى الشرق الأوسط والعالم.",
    },
    en: {
        title: "Logistics Bridge | China Sourcing, Import & Export & Global Logistics",
        desc: "Logistics Bridge — China sourcing, trading, import & export and international logistics from Guangzhou to the Middle East and the world.",
    },
};

export const C = {
    nav: {
        home: { ar: "الرئيسية", en: "Home" },
        about: { ar: "من نحن", en: "About Us" },
        services: { ar: "خدماتنا", en: "Services" },
        process: { ar: "الاستيراد والتصدير", en: "Import & Export" },
        markets: { ar: "الأسواق", en: "Markets" },
        whyus: { ar: "لماذا نحن؟", en: "Why Us" },
        contact: { ar: "تواصل معنا", en: "Contact" },
        compare: { ar: "قارن الموردين", en: "Compare Vendors" },
        cta: { ar: "واتساب", en: "WhatsApp" },
    },
    compare: {
        eyebrow: { ar: "مقارنة الموردين", en: "Vendor Comparison" },
        title: { ar: "قارن عروض الموردين بالذكاء الاصطناعي", en: "Compare supplier quotes with AI" },
        text: {
            ar: "أدخل مواصفاتك المطلوبة (المقاسات، السماكات، الأوزان، الخامات) وعرضي موردين على الأقل، وسنحللها بدقة: درجة لكل مورد، فحص مواصفة بمواصفة، المورد الأنسب، وسبب الاختيار بالتفصيل — مجانًا.",
            en: "Enter your required specifications (dimensions, thickness, weights, materials) and at least two supplier quotes for precise analysis: a score per supplier, spec-by-spec check, the best fit, and a fully detailed justification — free.",
        },
        specs: { ar: "المواصفات المطلوبة", en: "Required specifications" },
        specsPh: {
            ar: "مثال: ستانلس ستيل 304، سماكة 0.6mm، وزن الكوب 250g، قطر 8cm، تغليف فردي…",
            en: "e.g. stainless steel 304, 0.6mm thickness, 250g weight, 8cm diameter, individual packaging…",
        },
        winnerReason: { ar: "سبب الاختيار بالتفصيل", en: "Why this supplier — in detail" },
        specCheck: { ar: "فحص المواصفات", en: "Spec check" },
        statusLabels: {
            match: { ar: "مطابق", en: "Match" },
            close: { ar: "قريب", en: "Close" },
            missing: { ar: "مفقود", en: "Missing" },
            unknown: { ar: "غير محدد", en: "Unknown" },
        },
        product: { ar: "المنتج", en: "Product" },
        productPh: { ar: "مثال: أدوات مطبخ ستانلس ستيل", en: "e.g. stainless steel kitchenware" },
        quantity: { ar: "الكمية المطلوبة", en: "Quantity" },
        suppliers: { ar: "عروض الموردين", en: "Supplier quotes" },
        name: { ar: "اسم المورد", en: "Supplier name" },
        price: { ar: "سعر الوحدة (دولار)", en: "Unit price (USD)" },
        moq: { ar: "الحد الأدنى للطلب", en: "MOQ" },
        lead: { ar: "التسليم (يوم)", en: "Lead time (days)" },
        quality: { ar: "جودة العينة (1-5)", en: "Sample quality (1-5)" },
        certs: { ar: "الشهادات (اختياري)", en: "Certifications (optional)" },
        add: { ar: "إضافة مورد", en: "Add supplier" },
        submit: { ar: "قارن الآن", en: "Compare now" },
        analyzing: { ar: "جارٍ التحليل…", en: "Analyzing…" },
        winner: { ar: "المورد الموصى به", en: "Recommended supplier" },
        recommendation: { ar: "التوصية", en: "Recommendation" },
        tips: { ar: "نصائح التفاوض", en: "Negotiation tips" },
        quoteCta: { ar: "اطلب عرض سعر رسمي", en: "Request a formal quote" },
        minError: { ar: "أدخل موردين اثنين على الأقل", en: "Enter at least two suppliers" },
        failError: { ar: "تعذّر التحليل، حاول مرة أخرى", en: "Analysis failed, please try again" },
        disclaimer: { ar: "التحليل استرشادي ولا يغني عن التقييم الفني للعينات.", en: "The analysis is indicative and does not replace technical sample evaluation." },
        tableTitle: { ar: "مقارنة العروض بالتفصيل", en: "Detailed quote comparison" },
        total: { ar: "الإجمالي للكمية", en: "Total for quantity" },
        uploadCta: { ar: "قراءة من صورة / ملف", en: "Read from image / file" },
        reading: { ar: "جارٍ قراءة العرض…", en: "Reading quote…" },
        readOk: { ar: "تمت قراءة العرض — راجع البيانات وعدّلها إن لزم", en: "Quote read — review and adjust the details" },
        readFail: { ar: "تعذّر قراءة الملف — جرّب صورة أوضح أو أدخل البيانات يدويًا", en: "Could not read the file — try a clearer image or enter details manually" },
        fileHint: { ar: "صورة واضحة للعرض أو PDF — حتى 5MB", en: "A clear photo of the quote or PDF — up to 5MB" },
    },
    hero: {
        eyebrow: {
            ar: "Logistics Bridge — استيراد وتصدير ولوجستيات — قوانغجو، الصين",
            en: "LOGISTICS BRIDGE — SOURCING · TRADING · LOGISTICS — GUANGZHOU, CHINA",
        },
        line1: { ar: "جسرك الموثوق", en: "Your bridge between" },
        line2plain: { ar: "بين الصين ", en: "China and " },
        line2accent: { ar: "والأسواق العالمية", en: "global markets" },
        sub: {
            ar: "نقدّم حلول التوريد من الصين، والتجارة، والاستيراد والتصدير، والشحن الدولي بحريًا وجويًا — من قلب قوانغجو، وفروعنا في فوشان وييوو، إلى الشرق الأوسط وأسواق العالم.",
            en: "Sourcing, trading, import & export and international logistics solutions — from the heart of Guangzhou, with branches in Foshan and Yiwu, serving the Middle East and global markets.",
        },
        ctaPrimary: { ar: "تواصل معنا", en: "Contact Us" },
        ctaSecondary: { ar: "اكتشف خدماتنا", en: "Explore Services" },
        scroll: { ar: "مرّر للأسفل", en: "Scroll" },
        hubs: "PORT OF GUANGZHOU · BAIYUN INTL AIRPORT",
    },
    marquee: {
        items: {
            ar: [
                "التوريد من الصين",
                "الاستيراد والتصدير",
                "التخليص الجمركي",
                "الشحن البحري والجوي",
                "حلول الشرق الأوسط",
                "من قوانغجو إلى العالم",
            ],
            en: [
                "China Sourcing",
                "Import & Export",
                "Customs Clearance",
                "Sea & Air Freight",
                "Middle East Solutions",
                "From Guangzhou to the World",
            ],
        },
    },
    about: {
        eyebrow: { ar: "من نحن", en: "About Us" },
        title: {
            ar: "وجهةٌ صينيّة للتجارة الدولية",
            en: "A Chinese address for international trade",
        },
        statement: {
            ar: "من مقرّنا الرئيسي في قوانغجو، وفروعنا في فوشان وييوو، ندير أعمال الاستيراد والتصدير، ونربط المصنّعين الصينيين بالمشترين حول العالم عبر ممرات التجارة الدولية — بعنايةٍ بالتفاصيل، والتزامٍ بالمواعيد، ووضوحٍ في كل خطوة.",
            en: "From our headquarters in Guangzhou and our branches in Foshan and Yiwu, we run import and export operations, connecting Chinese manufacturers with buyers worldwide across international trade corridors — with care for detail, commitment to deadlines, and clarity at every step.",
        },
        p1: {
            ar: "نتولى دورة التجارة كاملة: من الاستشارة والتخطيط، مرورًا بالتوريد والتوثيق والتخليص الجمركي، وصولًا إلى الشحن البحري أو الجوي والتسليم النهائي.",
            en: "We handle the full trading cycle: from consultation and planning, through sourcing, documentation and customs clearance, to sea or air freight and final delivery.",
        },
        p2: {
            ar: "فريقنا يتواصل بالعربية والإنجليزية، ويعمل وفق الأنظمة الجمركية الصينية والدولية لضمان رحلةٍ تجارية سلسة بلا مفاجآت.",
            en: "Our team communicates in Arabic and English, and works within Chinese and international customs regulations to ensure a smooth journey with no surprises.",
        },
        hqTitle: { ar: "المقر الرئيسي — قوانغجو", en: "Headquarters — Guangzhou" },
        branchesLabel: { ar: "الفروع", en: "Branches" },
        branches: { ar: "فوشان · ييوو", en: "Foshan · Yiwu" },
        phoneLabel: { ar: "هاتف", en: "Phone" },
        addrLabel: { ar: "العنوان", en: "Address" },
        caption: "GUANGZHOU — HQ",
    },
    services: {
        eyebrow: { ar: "خدماتنا", en: "Our Services" },
        title: {
            ar: "خدماتٌ تغطي رحلة بضاعتك كاملة — من المصنع إلى بابك",
            en: "Services that cover your cargo's entire journey — factory to door",
        },
        ctaLabel: { ar: "اطلب هذه الخدمة", en: "Request this service" },
        items: [
            {
                id: "china-sourcing",
                num: "01",
                icon: "packagesearch",
                title: { ar: "التوريد من الصين", en: "China Sourcing" },
                desc: {
                    ar: "نحدد الموردين والمنتجات الأنسب لاحتياجك في كافة أنحاء الصين وفق مواصفاتك وميزانيتك وجدولك الزمني.",
                    en: "We identify the right suppliers and products across China to match your specifications, budget and timeline.",
                },
            },
            {
                id: "factory-sourcing",
                num: "02",
                icon: "factory",
                title: { ar: "البحث عن المصانع والموردين", en: "Supplier & Factory Sourcing" },
                desc: {
                    ar: "تقييم المصانع والتحقق من قدراتها الإنتاجية وشهاداتها وسجلها قبل التعاقد.",
                    en: "Vetted factories: we assess production capacity, certifications and track record before you commit.",
                },
            },
            {
                id: "procurement",
                num: "03",
                icon: "cart",
                title: { ar: "شراء المنتجات والتوريد", en: "Product Procurement" },
                desc: {
                    ar: "إدارة أوامر الشراء ومتابعة الإنتاج وجدولة التسليم مع الموردين نيابةً عنك.",
                    en: "We manage purchase orders, follow up production and schedule deliveries with suppliers on your behalf.",
                },
            },
            {
                id: "quality",
                num: "04",
                icon: "clipboard",
                title: { ar: "تنسيق فحص الجودة", en: "Quality Inspection Coordination" },
                desc: {
                    ar: "ترتيب فحوصات الجودة قبل الشحن للتأكد من مطابقة البضاعة للمواصفات المتفق عليها.",
                    en: "Pre-shipment quality inspections arranged to confirm goods match agreed specifications.",
                },
            },
            {
                id: "import-export",
                num: "05",
                icon: "globe",
                title: { ar: "الاستيراد والتصدير العام", en: "Import & Export" },
                desc: {
                    ar: "إدارة عمليات التبادل التجاري عبر الحدود من التخطيط والتنسيق حتى توصيل البضاعة.",
                    en: "Managing cross-border trade end to end — from planning and coordination to final delivery.",
                },
            },
            {
                id: "shipping",
                num: "06",
                icon: "ship",
                title: { ar: "الشحن الدولي بحريًا وجويًا", en: "International Shipping — Sea & Air" },
                desc: {
                    ar: "خيارات شحن بحري وجوي من موانئ الصين الرئيسية إلى وجهات العالم، مع تتبّعٍ مستمر.",
                    en: "Sea and air freight options from China's main ports to worldwide destinations, with continuous tracking.",
                },
            },
            {
                id: "freight",
                num: "07",
                icon: "truck",
                title: { ar: "الشحن والخدمات اللوجستية", en: "Freight & Logistics" },
                desc: {
                    ar: "تنسيق النقل الداخلي وتجميع البضائع والتخزين والجدولة حتى تحميل الحاويات.",
                    en: "Inland transport, cargo consolidation, warehousing and scheduling arranged up to container loading.",
                },
            },
            {
                id: "middle-east",
                num: "08",
                icon: "target",
                title: { ar: "حلول أسواق الشرق الأوسط", en: "Middle East Market Solutions" },
                desc: {
                    ar: "خبرة في خطوط التجارة نحو الشرق الأوسط: التوثيق والتخليص ومتطلبات كل سوق.",
                    en: "Deep familiarity with Middle East trade lanes: documentation, clearance and each market's requirements.",
                },
            },
        ],
    },
    process: {
        eyebrow: { ar: "الاستيراد والتصدير", en: "Import & Export" },
        title: {
            ar: "أربع خطوات… من الفكرة إلى التسليم",
            en: "Four steps — from idea to delivery",
        },
        steps: [
            {
                num: "01",
                title: { ar: "الاستشارة والتخطيط", en: "Consultation & Planning" },
                desc: {
                    ar: "نستمع لاحتياجك التجاري ونحدد مسار الشحن والجدول الزمني الأنسب لشحنتك.",
                    en: "We listen to your trade needs and define the most suitable freight route and timeline for your shipment.",
                },
            },
            {
                num: "02",
                title: { ar: "التوريد والتجهيز", en: "Sourcing & Preparation" },
                desc: {
                    ar: "ننسّق مع الموردين لتجهيز البضاعة وفحصها وتغليفها وفق متطلبات الشحن الدولي.",
                    en: "We coordinate with suppliers to prepare, inspect and pack goods according to international shipping requirements.",
                },
            },
            {
                num: "03",
                title: { ar: "التوثيق والتخليص", en: "Documentation & Clearance" },
                desc: {
                    ar: "نُنجز الفواتير وسندات الشحن وشهادات المنشأ وإجراءات الجمارك لدى الجهات المختصة.",
                    en: "We complete invoices, bills of lading, certificates of origin and customs procedures with the authorities.",
                },
            },
            {
                num: "04",
                title: { ar: "الشحن والتسليم", en: "Freight & Delivery" },
                desc: {
                    ar: "شحن بحري أو جوي مع تتبّعٍ مستمر، حتى وصول البضاعة إلى وجهتها بأمان.",
                    en: "Sea or air freight with continuous tracking, until your goods arrive safely at their destination.",
                },
            },
        ],
    },
    markets: {
        eyebrow: { ar: "الأسواق", en: "Markets" },
        title: {
            ar: "من قوانغجو… إلى كل دول العالم",
            en: "From Guangzhou… to every country in the world",
        },
        text: {
            ar: "من مقرّنا في قوانغجو — وفروعنا في فوشان وييوو — في قلب ممرات التجارة الصينية، نخدم كل دول العالم: الشرق الأوسط، وآسيا، وأوروبا، وأفريقيا، والأمريكتين — نشحن إلى أي ميناء أو مطار دولي، ونتولى التوثيق والتخليص ومتطلبات كل دولة.",
            en: "From our base in Guangzhou — with branches in Foshan and Yiwu — at the heart of China's trade corridors, we serve all countries worldwide: the Middle East, Asia, Europe, Africa and the Americas — shipping to any international port or airport, and handling each country's documentation, clearance and requirements.",
        },
        chips: [
            { ar: "كل دول العالم", en: "All Countries" },
            { ar: "الشرق الأوسط", en: "Middle East" },
            { ar: "الصين", en: "China" },
            { ar: "آسيا", en: "Asia" },
            { ar: "أوروبا", en: "Europe" },
            { ar: "أفريقيا والأمريكتين", en: "Africa & Americas" },
        ],
        nodes: ["EUROPE", "MIDDLE EAST", "ASIA", "WORLDWIDE"],
    },
    whyus: {
        eyebrow: { ar: "لماذا نحن؟", en: "Why Us?" },
        title: {
            ar: "لماذا يتعامل التجار معنا؟",
            en: "Why traders choose us",
        },
        items: [
            {
                icon: "mappin",
                title: {
                    ar: "مقرّ استراتيجي في قوانغجو",
                    en: "Strategic Guangzhou Base",
                },
                desc: {
                    ar: "من قلب جنوب الصين — قرب ميناء قوانغجو ومطار باييون الدولي، نقطتي الارتكاز الرئيسيتين للشحن البحري والجوي.",
                    en: "In the heart of southern China — near the Port of Guangzhou and Baiyun International Airport, the region's primary sea and air freight gateways.",
                },
            },
            {
                icon: "layers",
                title: {
                    ar: "حلول متكاملة شاملة",
                    en: "Truly End-to-End Solutions",
                },
                desc: {
                    ar: "خدمة واحدة تغطي التوريد والتوثيق والتخليص والشحن، دون تشتّتٍ بين وسطاء متعددين.",
                    en: "One service covering sourcing, documentation, clearance and freight — no juggling multiple intermediaries.",
                },
            },
            {
                icon: "shield",
                title: {
                    ar: "شفافية والتزام بالمعايير",
                    en: "Transparency & Compliance",
                },
                desc: {
                    ar: "وضوحٌ في التكاليف والإجراءات منذ أول تواصل، والتزامٌ تام بالأنظمة الجمركية الصينية والدولية.",
                    en: "Clarity on costs and procedures from the first contact, with full adherence to Chinese and international customs regulations.",
                },
            },
            {
                icon: "languages",
                title: { ar: "تواصلٌ بلغتك", en: "Communication in Your Language" },
                desc: {
                    ar: "فريقٌ يتحدث العربية والإنجليزية، يُبقيك على اطلاعٍ بخطى شحنتك في كل مرحلة.",
                    en: "A team speaking Arabic and English, keeping you informed of your shipment's progress at every stage.",
                },
            },
        ],
    },
    contact: {
        eyebrow: { ar: "تواصل معنا", en: "Contact Us" },
        title: { ar: "لنبدأ شحنتك القادمة", en: "Let's start your next shipment" },
        text: {
            ar: "أخبرنا عن بضاعتك ووجهتك والخدمة التي تحتاجها، وسنعود إليك بخطةٍ وعرض سعر. يمكنك أيضًا مراسلتنا مباشرة عبر واتساب أو الهاتف.",
            en: "Tell us about your goods, destination and the service you need, and we'll come back with a plan and a quote. You can also reach us directly on WhatsApp or by phone.",
        },
        whatsappCta: { ar: "مراسلة واتساب", en: "Chat on WhatsApp" },
        callCta: { ar: "اتصال مباشر", en: "Direct Call" },
        personLabel: { ar: "جهة الاتصال", en: "Contact person" },
        form: {
            name: { ar: "الاسم", en: "Name" },
            company: { ar: "الشركة", en: "Company" },
            country: { ar: "الدولة", en: "Country" },
            phone: { ar: "واتساب / الهاتف", en: "WhatsApp / Phone" },
            email: { ar: "البريد الإلكتروني", en: "Email" },
            service: { ar: "الخدمة المطلوبة", en: "Service required" },
            servicePlaceholder: { ar: "اختر الخدمة…", en: "Select a service…" },
            serviceOther: { ar: "أخرى", en: "Other" },
            message: { ar: "رسالتك", en: "Your message" },
            msgPlaceholder: {
                ar: "اكتب تفاصيل بضاعتك، وجهتها، والخدمة التي تحتاجها…",
                en: "Describe your goods, destination and the service you need…",
            },
            submit: { ar: "أرسل الرسالة", en: "Send Message" },
            sending: { ar: "جارٍ الإرسال…", en: "Sending…" },
            success: {
                ar: "تم استلام رسالتك بنجاح — سنتواصل معك قريبًا.",
                en: "Message received — we'll get back to you soon.",
            },
            error: {
                ar: "تعذّر الإرسال، حاول مرة أخرى أو راسلنا عبر واتساب.",
                en: "Sending failed — please try again or reach us on WhatsApp.",
            },
        },
        waPrefill: {
            ar: "مرحبًا، أرغب بالاستفسار عن خدمات الاستيراد والتصدير.",
            en: "Hello, I would like to inquire about your import & export services.",
        },
    },
    footer: {
        tagline: {
            ar: "توريد · استيراد · تصدير · تخليص جمركي · شحن دولي",
            en: "Sourcing · Import · Export · Customs Clearance · Freight",
        },
        servicesTitle: { ar: "خدماتنا", en: "Our Services" },
        linksTitle: { ar: "روابط سريعة", en: "Quick Links" },
        contactTitle: { ar: "بيانات التواصل", en: "Contact" },
        rights: {
            ar: "جميع الحقوق محفوظة",
            en: "All rights reserved",
        },
    },
};

export const IMAGES = {
    hero:
        "https://images.pexels.com/photos/37828492/pexels-photo-37828492.jpeg?auto=compress&cs=tinysrgb&w=1600",
    port:
        "https://images.unsplash.com/photo-1789898575660-830b35ab691d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gz:
        "https://images.unsplash.com/photo-1762964601999-c9a45aabe875?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
